import { UserAccount } from '@shared/features/account/interfaces/customer.interface';

export class AddCustomerInfo {
  static readonly type = '[Customer] AddCustomerInfo';

  constructor(public customer: UserAccount) {}
}
